import React, { FC } from "react";
import { Alert, alertPropertyMap } from "../../../../components/alerts/Alert";
import { ItemErrorMsg } from "../../../../types/cart";
import { StyledError, StyledNote } from "./index.styled";

interface ErrorProps {
  errorMsgs: ItemErrorMsg[];
}

export const Error: FC<ErrorProps> = ({ errorMsgs }) => (
  <StyledError>
    {errorMsgs.map((err, i) => {
      const { alertType, note, title } = err;
      return (
        <div key={`item-error-msg-${i}`}>
          <Alert type={alertType} bold small>
            {title}
          </Alert>
          <StyledNote color={alertPropertyMap[alertType].textColor}>
            {note}
          </StyledNote>
        </div>
      );
    })}
  </StyledError>
);
